import { render, staticRenderFns } from "./UserAssessment.vue?vue&type=template&id=0d466fcc"
import script from "../../../scripts/partials/user/UserAssessment.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/user/UserAssessment.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports